import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { PapiBadge, PapiUser } from '@wix/da-papi-types';
import Badge from '@wix/da-shared-react/pkg/Badge';
import XTimesIcon from '@wix/da-ds/pkg/Icons/XTimes';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';
import { Url } from '@wix/da-url';
import { AppState } from '../../../../../../types/store';
import { getProfileOwnerUser } from '../../../../../selectors/users';

import s from './BadgeBox.scss';

export interface Props {
  item: PapiBadge;
  className?: string;
  profileOwnerUser?: PapiUser;
}

const enhance = connect((state: AppState) => ({
  profileOwnerUser: getProfileOwnerUser(state),
}));

export class BadgeBox extends React.PureComponent<Props> {
  render() {
    const { profileOwnerUser, item, className } = this.props;

    const classes = classnames(s['root'], className);
    if (profileOwnerUser) {
      const url = Url.badgesLink(profileOwnerUser.username, item.id);
      return (
        <a className={classes} href={url}>
          {this.renderContent()}
        </a>
      );
    }

    return <div className={classes}>{this.renderContent()}</div>;
  }

  renderContent() {
    const { item } = this.props;
    const count = item.stackCount || 1;
    const shortCount = shortenNumber(count, 0);
    const showRealCountInTitle = String(count) !== shortCount;
    return (
      <>
        <div className={s['badge-info']}>
          <Badge {...item} className={s['badge-icon']} />
          <XTimesIcon
            className={classnames(s['icon'], s['xtimes-icon'])}
            withPadding
            condensed
          />
          <span
            className={s['badge-count']}
            title={String(showRealCountInTitle && count)}
          >
            {shortCount}
          </span>
        </div>
        <div className={s['badge-title']}>
          <span className={s['badge-title-text']}>{item.baseTitle}</span>
        </div>
      </>
    );
  }
}

export default enhance(BadgeBox);
